"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class LogoIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "30", height: "30", viewBox: "0 0 30 30" },
            React.createElement("defs", null,
                React.createElement("circle", { id: "a", cx: "15", cy: "15", r: "15" })),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("mask", { id: "b", fill: fill },
                    React.createElement("use", { xlinkHref: "#a" })),
                React.createElement("path", { fill: fill, d: "M-9.15 24.75c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z", mask: "url(#b)" }),
                React.createElement("circle", { cx: "39.15", cy: ".75", r: "24", fill: fill, mask: "url(#b)" }),
                React.createElement("path", { fill: fill, d: "M15 66.45c13.255 0 24-10.628 24-23.925C39 29.23 28.255 18.45 15 18.45S-9 29.229-9 42.525C-9 55.822 1.745 66.45 15 66.45z", mask: "url(#b)" }))));
    }
}
exports.LogoIcon = LogoIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/logo.tsx
// module id = 2150
// module chunks = 0 1 2